import type { Dispute, Message } from '../types/dispute.types'

export const mockDisputes: Dispute[] = [
    {
        id: 'DIS-001',
        orderId: 'ORD-001',
        customer: 'John Doe',
        merchant: 'ABC Building Supplies',
        subject: 'Product quality issue',
        description: 'The cement bags received were damaged and some bags were torn.',
        priority: 'high',
        status: 'in_progress',
        assignedTo: 'Support Agent 1',
        createdAt: '2024-12-23',
        ageHours: 36,
    },
    {
        id: 'DIS-002',
        orderId: 'ORD-003',
        customer: 'Jane Smith',
        merchant: 'XYZ Materials',
        subject: 'Delayed delivery',
        description: 'Order was supposed to be delivered on 20th Dec but still not received.',
        priority: 'medium',
        status: 'open',
        createdAt: '2024-12-24',
        ageHours: 12,
    },
    {
        id: 'DIS-003',
        orderId: 'ORD-005',
        customer: 'Bob Wilson',
        merchant: 'DEF Supplies',
        subject: 'Wrong product delivered',
        description: 'Ordered 12mm TMT bars but received 10mm bars instead.',
        priority: 'critical',
        status: 'resolved',
        assignedTo: 'Support Agent 2',
        createdAt: '2024-12-20',
        ageHours: 96,
        resolution: 'Product replaced with correct specification. Customer satisfied.',
    },
]

export const mockMessages: Message[] = [
    {
        id: '1',
        sender: 'John Doe',
        role: 'customer',
        message: 'I received damaged cement bags. Several bags are torn and the quality seems poor.',
        timestamp: '2024-12-23 10:00 AM',
    },
    {
        id: '2',
        sender: 'ABC Building Supplies',
        role: 'merchant',
        message: 'We apologize for the inconvenience. Can you please share photos of the damaged bags?',
        timestamp: '2024-12-23 11:30 AM',
    },
    {
        id: '3',
        sender: 'Support Agent 1',
        role: 'admin',
        message: 'We are investigating this issue. Please provide photos as requested by the merchant.',
        timestamp: '2024-12-23 02:00 PM',
    },
]
